//import Siema from 'siema';

/*import 'tiny-slider/dist/tiny-slider.css';
import { tns } from 'tiny-slider'*/

import 'flickity/dist/flickity.css';
import Flickity from 'flickity';

class TitleStartpageSlider {

    constructor(element) {
        console.log('TitleStartpageSlider.constructor', element);
        this.element = element;
        this.slides = this.element.getElementsByClassName('slides')[0];
        this.slider = new Flickity(this.slides, {
            prevNextButtons: false,
            selectedAttraction: 0.2,
            friction: 0.8,
            //autoPlay: 5000
        });
    }

    destroy() {
        console.log('TitleStartpageSlider.destroy', this.element);
        this.slider.destroy();
    }
}

TitleStartpageSlider.elementClassName = 'title-startpage-slider';
TitleStartpageSlider.instances = [];
TitleStartpageSlider.init = function() {
    console.log('TitleStartpageSlider.init');
    var elements = document.getElementsByClassName( TitleStartpageSlider.elementClassName );
    for (const element of Array.from(elements)) {
        TitleStartpageSlider.instances.push(new TitleStartpageSlider(element));
    }
    console.log('TitleStartpageSlider.instances.length', TitleStartpageSlider.instances.length);
};

TitleStartpageSlider.onDispose = function() {
    console.log('TitleStartpageSlider.onDispose');
    while (TitleStartpageSlider.instances.length){
        console.log('TitleStartpageSlider.instances.length', TitleStartpageSlider.instances.length);
        let instance = TitleStartpageSlider.instances.pop();
        instance.destroy();
        instance = null;
    }
};

export default TitleStartpageSlider;

if (module.hot) {
    module.hot.dispose(TitleStartpageSlider.onDispose);
}


